import ClientsList from "components/clients/ClientsList";
import Layout from "../components/Layout";
import { Grid } from "@mui/material";
import ClientDetails from "components/clients/ClientDetails";
import { useAppDispatch, useTrading } from "features/store";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { setCurrentClient, setCurrentAccount } from "features/trading/tradingSlice";

export default function ClientsPage() {
  const { currentClientId } = useTrading();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  const clientIdFromUrl = searchParams.get("client_id") ? Number(searchParams.get("client_id")) : null;
  const accountIdFromUrl = searchParams.get("account_id") ? Number(searchParams.get("account_id")) : null;
  const strategyIdFromUrl = searchParams.get("strategy_id") ? Number(searchParams.get("strategy_id")) : null;

  useEffect(() => {
    if (clientIdFromUrl) dispatch(setCurrentClient(clientIdFromUrl));
    if (accountIdFromUrl) dispatch(setCurrentAccount(accountIdFromUrl));
  }, [clientIdFromUrl, accountIdFromUrl, dispatch]);

  const activeClientId = currentClientId || clientIdFromUrl;

  return (
    <Layout title="Clients" content="Clients page">
      <Grid container>
        <Grid item xs={12} md={4}>
          <ClientsList />
        </Grid>
        {activeClientId && (
          <Grid item xs={12} md={8}>
            <ClientDetails initialStrategyId={strategyIdFromUrl} />
          </Grid>
        )}
      </Grid>
    </Layout>
  );
}
